//TODO: Machine grid Config
import { ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";
import { LookupFilter } from "../../../records/grids/columns/filters/subFilters/LookupFilter";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import {
  decimalValueGetterFactory,
  lookupValueGetterFactory,
  moneyValueGetterFactory,
  percentageValueGetterFactory,
} from "../../../records/grids/cells/valueGetters";
import { OptionsFilter } from "../../../records/grids/columns/filters/subFilters/OptionsFilter";
import { MachineConfigurationViewGateway } from "../models/machineConfiguration";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
  IGridSettings,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import { machineConfigurationObjectName } from "../../shared/names";

MachineConfiguration.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];

export const vsObjectName = machineConfigurationObjectName;
export const defaultSort = "PropertyName,Status,Location,SerialNumber";

const getUrl = (path?: string) =>
  path === undefined ? `/api/machines/Machine` : `/api/machines/${path}`;

export function MachineConfiguration(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionServiceName,
    "$compile",
    ServerUtilityName,
    (
      columnDefinitionService: ColumnDefinitionService,
      $compile: ICompileService,
      serverUtility: ServerUtility
    ) => [
      columnDefinitionService.getNumberColDef({
        field: "Id",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "SerialNumber",
        header: "Serial Number",
        filter: new FilterProvider("SerialNumber", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["MachineId"],
              serverQuery: (search) =>
                serverUtility.query({
                  url: getUrl(),
                  query: {
                    SerialNumberContains: search,
                    Take: 10,
                    OrderBy: "SerialNumber",
                  },
                }),
              displayField: "SerialNumber",
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getDateColDef({
        field: "ManufacturersDate",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineManufacturerName",
        header: "Manufacturer",
        filter: new FilterProvider("MachineManufacturerName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["MachineManufacturerId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("MachineManufacturer"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineModelTypeName",
        header: "Model Type",
        filter: new FilterProvider("MachineModelTypeName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["MachineModelTypeId"],
              serverQuery: (search) =>
                serverUtility
                  .lookupQuery({
                    url: getUrl("MachineModelType"),
                    search,
                  })
                  .then((result) => {
                    return result;
                  }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineModelName",
        header: "Model",
        filter: new FilterProvider("MachineModelName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["MachineModelId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("MachineModel"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getNumberColDef({
        field: "Order",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ChangeType",
        hide: true,
        valueGetter: lookupValueGetterFactory({
          lookup: {
            NewMachine: "New Machine",
          },
        }),
        filter: new FilterProvider("ChangeType", $compile)
          .addFilter(
            "=",
            new OptionsFilter({
              displayName: "=",
              queryFieldNames: ["ChangeType"],
              options: [
                { display: "Decommission", value: "Decommission" },
                { display: "Conversion", value: "Conversion" },
                { display: "Move", value: "Move" },
                { display: "New Machine", value: "NewMachine" },
                { display: "Warehouse", value: "Warehouse" },
              ],
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "Status",
        filter: new FilterProvider("Status", $compile)
          .addFilter(
            "=",
            new OptionsFilter({
              displayName: "=",
              options: [
                { display: "Floor", value: "Floor" },
                { display: "Warehoused", value: "Warehoused" },
                { display: "Decommissioned", value: "Decommissioned" },
              ],
              queryFieldNames: ["Status"],
              includeNullValue: true,
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getBooleanColDef({
        field: "CurrentConfiguration",
        hide: true,
      }),
      columnDefinitionService.getDateColDef({
        field: "InServiceDate",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "SlotNumber",
        header: "Asset Number",
      }),
      columnDefinitionService.getStringColDef({
        field: "Notes",
        hide: true,
      }),
      columnDefinitionService.getDateColDef({
        field: "Date",
        header: "Project Date ",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ProjectNumber",
        header: "Project Number",
      }),
      columnDefinitionService.getStringColDef({
        field: "PropertyName",
        header: "Property",
        filter: new FilterProvider("PropertyName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["PropertyId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: "/api/properties",
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineAreaName",
        header: "Area",
        hide: true,
        filter: new FilterProvider("MachineAreaName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["MachineAreaId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("MachineArea"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineZoneName",
        header: "Zone",
        hide: true,
        filter: new FilterProvider("MachineZoneName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["MachineZoneId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("MachineZone"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineBankName",
        header: "Bank",
        hide: true,
        filter: new FilterProvider("MachineBankName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["MachineBankId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("MachineBank"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "Position",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Location",
      }),
      columnDefinitionService.getNumberColDef({
        field: "BillValidatorCapacity",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineGameCategoryName",
        hide: true,
        header: "Game Category",
        filter: new FilterProvider("MachineGameCategoryName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["MachineGameCategoryId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("MachineGameCategory"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getNumberColDef({
        field: "JackpotLimit",
        valueGetter: moneyValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CreditLimit",
        valueGetter: moneyValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "PrinterLimit",
        valueGetter: moneyValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "BillLimit",
        valueGetter: moneyValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Topper",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "Roulette",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "RouletteId",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "MeterDelta",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "TournamentEnabled",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveDefinitionName",
        filter: new FilterProvider("ProgressiveDefinitionName", $compile)
          .defaultStringFilters()
          .addNullFilter("ProgressiveDefinitionId")
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["ProgressiveDefinitionId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: "/api/machines/progressives/ProgressiveDefinition",
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveTypeName",
        filter: new FilterProvider("ProgressiveTypeName", $compile)
          .defaultStringFilters()
          .addNullFilter("ProgressiveTypeId")
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["ProgressiveTypeId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: "/api/machines/progressives/ProgressiveType",
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "LinkId",
        header: "Link ID",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveControllerVersion",
        header: "Prog Controller Version",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveControllerSerialNumber",
        header: "Prog Controller Serial #",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveSoftware1",
        header: "Controller Software (1)",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveSoftware2",
        header: "Controller Software (2)",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "LeasedSoftware",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "DailyFee",
        hide: true,
        valueGetter: moneyValueGetterFactory(),
      }),
      columnDefinitionService.getNumberColDef({
        field: "CoinInPercentage",
        hide: true,
        valueGetter: percentageValueGetterFactory(),
      }),
      columnDefinitionService.getNumberColDef({
        field: "MinDaysNotification",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "IViewVersionName",
        header: "iView Version",
        filter: new FilterProvider("IViewVersionName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["IViewVersionId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("IViewVersion"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "IViewContent",
        header: "iView Content",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "IViewOSVersion",
        header: "iView OS Version",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "NXPFirmware",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "GenesisFirmware",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "GMUDOCID",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ROMSIGSoftwareName",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "PrinterManufacturer",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "PrinterModel",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "PrinterSerialNumber",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "BillValidatorManufacturer",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "BillValidatorModel",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "BVSerialNumber",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MainDoorMD5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MainDoorMD1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CPU5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CPU1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "BellyDoorBVS5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "BellyDoorBVS1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CashboxBVC5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CashboxBVC1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CashBoxDoorBVA5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CashBoxDoorBVA1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "ElectricalBaseELE5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "ElectricalBaseELE1_1_8",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "AccountingMachineDenominationValue",
        header: "Accounting Denomination",
        hide: true,
        valueGetter: (params) =>
          (<MachineConfigurationViewGateway>params.data)
            .AccountingMachineDenominationName,
        filter: new FilterProvider(
          "AccountingMachineDenominationValue",
          $compile
        )
          .defaultNumberFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["AccountingDenominationId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("MachineDenomination"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "BaseDenomValue",
        header: "Base Denom",
        hide: true,
        valueGetter: (params) =>
          (<MachineConfigurationViewGateway>params.data).BaseDenom,
        filter: new FilterProvider("BaseDenomValue", $compile)
          .defaultNumberFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["BaseMachineDenominationId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("MachineDenomination"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "PrimaryTheme",
        header: "Theme",
        hide: true,
        filter: new FilterProvider("PrimaryTheme", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["PrimaryMachineThemeId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: getUrl("MachineTheme"),
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getBooleanColDef({
        field: "MultiTheme",
        header: "Multi Theme",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "MultiDenom",
        header: "Multi Denom",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MinPaybackPercentage",
        header: "Min Payback %",
        hide: true,
        valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxPaybackPercentage",
        header: "Max Payback %",
        hide: true,
        valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxPaybackWithContribution",
        header: "Max Payback with PC",
        hide: true,
        valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "HoldPercentage",
        header: "Hold %",
        hide: true,
        valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getBooleanColDef({
        field: "VariableHoldPercentage",
        header: "Variable Hold %",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxBet",
        header: "Max Bet",
        hide: true,
        valueGetter: decimalValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "TopCreditsAward",
        header: "Top Award (Credits)",
        hide: true,
        valueGetter: decimalValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "TopDollarAward",
        header: "Top Award ($)",
        hide: true,
        valueGetter: moneyValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getStringColDef({
        field: "PaytableId",
        header: "Paytable ID",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Paylines",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Ownership",
        hide: true,
        valueGetter: lookupValueGetterFactory({
          lookup: {
            LeasedOwned: "Leased/Owned",
          },
        }),
        filter: new FilterProvider("Ownership", $compile)
          .addFilter(
            "=",
            new OptionsFilter({
              displayName: "=",
              queryFieldNames: ["Ownership"],
              options: [
                { display: "Owned", value: "Owned" },
                { display: "Leased", value: "Leased" },
                { display: "Leased/Owned", value: "LeasedOwned" },
              ],
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "ContractNumber",
        hide: true,
      }),
      columnDefinitionService.getDateColDef({
        field: "ContractExpiryDate",
        hide: true,
      }),
    ],
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      const gridSettings = gridSettingsService.getGridSettings(
        Symbol("main.machines.grid")
      );
      return {
        columnDefinitionSet: vsObjectName,
        defaultSort,
        nameSingular: "Machine",
        namePlural: "Machines",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/MachineConfiguration"
        ),
        showAddButton: true,
        showAddButtonPermission: "machineEdit",
        gridSettings,
        showSelectButtons: true,
      };
    },
  ]);
}
